import { createRoutine } from 'redux-saga-routines';
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { get } from 'lodash/fp';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'quer... Remove this comment to see the full error message
import queryString from 'query-string';
import { AnyAction } from 'redux';
import api, { API_HOST } from '../helpers/api';

export const getPDS = createRoutine('pds/GET_PDS');
export const clearPDS = createRoutine('pds/CLEAR_PDS');

function* handleGetPDS({ payload: id }: AnyAction) {
  try {
    const user = yield select(get('user.data'));
    const locale = yield select(get('intl.locale'));
    const searchParams = queryString.stringify({ language: locale });
    yield put(getPDS.request());
    const pds = yield call(api.get, `${API_HOST}/pds/${id}/?${searchParams}`, !!user);
    yield put(getPDS.success({ locale, id, pds }));
  } catch (error) {
    yield put(getPDS.failure(error));
  } finally {
    yield put(getPDS.fulfill());
  }
}

export function* pdsSaga() {
  yield takeLatest(getPDS.TRIGGER, handleGetPDS);
}
